import  gql  from 'graphql-tag'

export const productTypes = gql`query productTypes($isActive: Boolean){ 
    productTypes(isActive:$isActive){
            edges{
                node{
                    id,
                    code,
                    name,
                    isActive
                }
            }
        }
    }`;
